module.exports = __webpack_public_path__ + "web/img/excel.5d9d27ee.png";